<div style="display: none;" id='id-trip'>{{response | json}}</div>
<div class="detail-information" *ngIf="response?.tripid !== 0">
  <div class="detail-information-header">
    <div>
      <span class="title-dih">Detail information</span>
    </div>
    <div class="detail-information-header-first">
      <div class="contain-text-dihf">
        <div class="lisence-plate">License plate: {{response?.platE_NUMBER || ''}}</div>
        <div class="text-plate">Completed trips today: {{response?.amountofjourneys}}</div>
      </div>
      <div class="contain-text-dihf">
        <div class="text-plate">Plant: {{response?.plant}}</div>
        <div class="text-plate">Avg time of completed trips today: {{response?.avG_TIME}}</div>
      </div>
    </div>
  </div>
  <div>
    <hr>
  </div>
  <div class="detail-information-gallery">
    <div>
      <span class="text-plate">Image from: </span>
      <span id="facilityPoint" class="lisence-plate">{{response?.facilitY_POINT}}</span>
    </div>
    <div class="image-container">
      <img #image src="{{response?.images[0].imagE_URL}}" alt="{{response?.images[0].steP_NAME}}">
    </div>
    <div class="sub-images">
      <div>
        <div class="pagination">
          <a class="image-page" (click)="setImage(i,response?.images)">&laquo;</a>
          <a class="image-page" id="image-{{i}}" (click)="setImage(i,response?.images)"
            *ngFor="let item of response?.images; let i = index">{{i+1}}</a>
          <a class="image-page" (click)="setImage(i,response?.images)">&raquo;</a>
        </div>
        <!-- <cwc-pagination #pagination active-page="1" [totalPages]="response?.images.length"
          (cwcChange)="cwcChange($event)"></cwc-pagination> -->
      </div>
      <!-- <div class="expand-download">
        <div>
          <span>Expand Image</span>
        </div>
        &nbsp;
        &nbsp;
        <div>
          <span>Download all</span>
        </div>
      </div> -->
    </div>
  </div>
  <div>
    <hr>
  </div>
  <div class="detail-information-details">
    <div class="did-item">
      <div class="p16">
        <div class="container-message">
          <div class="container-message-item">
            <img *ngIf="response?.color==='OK'" src="../../../../../assets/images/Icons/Check-circle.png" alt="">
            <img *ngIf="response?.color==='ERROR'" src="../../../../../assets/images/Icons/X-circle.png" alt="">
          </div>
          <div class="container-message-item">
            <div>
              <span class="container-message-item-title">{{response?.messagetitle}}</span>
            </div>
            <div>
              <span class="text-status">{{response?.message}}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="did-item edit-plate">
      <div>
        <div id="tripid" style="display: none;">{{response?.tripid}}</div>
        <div id="platenumber" style="display: none;">{{response?.platE_NUMBER}}</div>
        <form [formGroup]="editPlateForm" (ngSubmit)="editPlate(editPlateForm.value)">
          <div class="container-controls">
            <div class="lp-container">
              <div>
                <span class="lp-text">
                  License plate
                </span>
              </div>
              <div>
                <input id="licensePlate" type="text" formControlName="licensePlate" autocomplete="off"
                  class="uppercase width-full" disabled="true" value="{{response?.platE_NUMBER}}"
                  (keypress)="validate($event)" [maxlength]=100>
              </div>
            </div>
            <div class="form-control-container">
              <button (click)="beEditable()" *ngIf="!editable">Edit</button>
            </div>
            <div class="form-control-container">
              <button (click)="beNotEditable()" *ngIf="editable">Cancel</button>
            </div>
            <div class="form-control-container">
              <button type="submit" *ngIf="editable">Save</button>
            </div>
          </div>
          <div id="update-lp" style="display: none; color: #8cc658;">
            <p>Lisence plate updated successfully</p>
          </div>
        </form>
      </div>
    </div>
    <div class="did-item truck-path-detail">
      <div>
        <span class="title-dih">Truck path</span>
      </div>
      <div class="grid-truck-path">
        <div class="item-grid-truck-path nombre">
          <div class="item-nombre">
            <span class="title-points">Facility point</span>
          </div>
          <div class="item-nombre">
            <span class="title-points">Total tons</span>
          </div>
          <div class="item-nombre">
            <span class="title-points">Time</span>
          </div>
          <div class="item-nombre">
            <span></span>
          </div>
        </div>
        <div class="item-grid-truck-path barra">
          <div class="item-barra">
            <div class="bolita"></div>
          </div>
          <div class="item-barra">
            <div class="bolita"></div>
          </div>
          <div class="item-barra">
            <div class="bolita"></div>
          </div>
          <div class="item-barra">
            <div class="bolita"></div>
          </div>
        </div>
        <div class="item-grid-truck-path points">
          <div class="fp-ld">
            <div class="text-points">Entrance</div>
            <div class="text-points"></div>
            <div class="text-points"></div>
            <div class="link-points">
              <!--(click)="filterImages(1)"> -->
              <!--<img src="../../../../../assets/images/Icons/Eye.png" alt="">
               <span class="text-view">View image</span> -->
            </div>
          </div>
          <div class="fp-ld">
            <div class="text-points">Yard</div>
            <div class="text-points">{{response?.checkpoinT_STEPS[0].totaL_TONS}}</div>
            <div class="text-points">{{response?.checkpoinT_STEPS[0].averagE_TIME}}</div>
            <div class="link-points" (click)="filterImages(1)">
              <!--<img src="../../../../../assets/images/Icons/Eye.png" alt="">
               <span class="text-view">View image</span> -->
            </div>
          </div>
          <div class="fp-ld">
            <div class="text-points">Silo</div>
            <div class="text-points">{{response?.checkpoinT_STEPS[1].totaL_TONS}}</div>
            <div class="text-points">{{response?.checkpoinT_STEPS[1].averagE_TIME}}</div>
            <div class="link-points" (click)="filterImages(2)">
              <!--<img src="../../../../../assets/images/Icons/Eye.png" alt="">
              <span class="text-view">View image</span> -->
            </div>
          </div>
          <div class="fp-ld">
            <div class="text-points">Exit guard</div>
            <div class="text-points">{{response?.checkpoinT_STEPS[2].totaL_TONS}}</div>
            <div class="text-points">{{response?.checkpoinT_STEPS[2].averagE_TIME}}</div>
            <div class="link-points" (click)="filterImages(3)">
              <!--<img src="../../../../../assets/images/Icons/Eye.png" alt="">
               <span class="text-view">View image</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="response?.tripid === 0">
  {{'NODATATRIP'|translate}}
</div>
